import ProductCard from "components/ProductCard";
import { PRODUCTS, Product } from "data/data";
import ButtonSecondary from "shared/Button/ButtonSecondary";
import CommonLayout from "./CommonLayout";
import { useEffect, useState } from "react";
import WishlistService from "app/services/wishlistService";
import Dash from "containers/dash";

const AccountSavelists = () => {
  const [products, setProducts] = useState<Product[]>([]);
  useEffect(() => {
      
    WishlistService.getWishlistView().then(data => {
        
      setProducts(data)
       
    })
}, [])
  const renderSection1 = () => {
  
    return ( 
      <div className="space-y-10 sm:space-y-12 md:p-10">
        <div>
          <h2 className="text-2xl sm:text-3xl font-semibold">
            Wishlist
          </h2>
        </div>

        <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 ">
          {products.filter((_, i) => i < 6).map((stay) => (
            <ProductCard key={stay.id} data={stay} />
          ))}
        </div>
       
      </div>
    );
  };

  return (
    
      <Dash>{renderSection1()}</Dash>

  );
};

export default AccountSavelists;
